module.exports = __webpack_public_path__ + "static/media/icon-open-right.c2a0a3aa.svg";